export enum MySortButtonStatesEnum {
    DISABLED  = 0,
    DESCENT = 1,
    ASCENT = 2,
}
